import { Tooltip } from 'react-daisyui'
import Icon from '../../icons'

 
const Label: React.FC<{
    text: string
    isBold?: boolean
    required?: boolean
    isCapitalize?: boolean
    isError?: boolean
    info?: string

}> = ({ text, isBold, required, isCapitalize, isError, info }) => (
    <div className="flex items-center gap-1">
        <p  className={`${isBold ? 'font-bold' : 'font-normal'} ${isCapitalize ? 'capitalize' : ''} ${isError ? 'text-red-500' : ''} text-[0.938rem] leading-none`}>
            {text}
            {required && <span className="text-red-600 ml-1">*</span>}
        </p>
        {info && (
            <Tooltip message={info} color="info">
                {/* <Icon name="outlineInfoCircle" size={'0.45rem'} /> */}
            </Tooltip>
        )}
    </div>
)
export default Label